import { IEmployee } from "../../employee/employee";
import { ITenantSettings } from "../../setting/tenant-settings/models/tenant-setting";
import { TimeSpan } from "./time-span";

// Hours of an overtime compensation that the available overtime balance does not cover and that
// therefore end up on the flex time balance. 0 means the balance covers the whole request.
// ponytail: estimated from the tenant's default daily target over Mon-Fri; the server splits per day
// against the employee's own work time, so the hint can be off for part-time staff and holidays.
export function overtimeFlexTimeFallbackHours(
  employee: IEmployee,
  tenantSettings: ITenantSettings,
  dateFrom: Date,
  dateTo: Date,
  isHalfDayStart: boolean,
  isHalfDayEnd: boolean
): number {
  if(!employee || !tenantSettings || !dateFrom || !dateTo){
    return 0;
  }

  const dailyTargetHours = TimeSpan.parse(tenantSettings.defaultWorkTime).getTotalSeconds() / 3600;
  const workDays = countWorkDays(dateFrom, dateTo);

  if(dailyTargetHours <= 0 || workDays <= 0){
    return 0;
  }

  const halfDays = (isHalfDayStart ? 0.5 : 0) + (isHalfDayEnd ? 0.5 : 0);
  const requestedHours = Math.max(0, workDays - halfDays) * dailyTargetHours;
  const availableHours = Math.max(0, TimeSpan.parse(employee.overtimeBalance).getTotalSeconds() / 3600);

  return Math.max(0, requestedHours - availableHours);
}

function countWorkDays(dateFrom: Date, dateTo: Date): number {
  const current = new Date(dateFrom);
  current.setHours(0, 0, 0, 0);

  const last = new Date(dateTo);
  last.setHours(0, 0, 0, 0);

  let workDays = 0;

  while(current <= last){
    const weekDay = current.getDay();

    if(weekDay !== 0 && weekDay !== 6){
      workDays++;
    }

    current.setDate(current.getDate() + 1);
  }

  return workDays;
}
